module.exports = __webpack_public_path__ + "122cd92a3b2a7fadaf77541750e172aa.svg";